"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERVIEW = void 0;
var OVERVIEW = {
  BUTTON__EDIT_SUPPLIER: 'newPendingUpdateOverview-button-editSupplier',
  TEXT__SUPPLIER_NAME: 'newPendingUpdateOverview-span-supplierName',
  TEXT__ORDER_DATE: 'newPendingUpdateOverview-span-orderDate',
  BUTTON__EDIT_INFO: 'newPendingUpdateOverview-button-editInfo',
  TEXT__ADDITIONAL_INFO: 'newPendingUpdateOverview-span-additionalInfo',
  TEXT__PRIMARY_CONTACT_NAME: 'newPendingUpdateOverview-span-primaryContactName',
  TEXT__PRIMARY_CONTACT_PHONE: 'newPendingUpdateOverview-span-primaryContactPhone',
  TEXT__ADDRESS_STREET: 'newPendingUpdateOverview-span-addressStreet',
  TEXT__ADDRESS_CITY: 'newPendingUpdateOverview-span-addressCity',
  TEXT__ADDRESS_ZIP_CODE: 'newPendingUpdateOverview-span-addressZipCode',
  TEXT__ADDRESS_COUNTRY: 'newPendingUpdateOverview-span-addressCountry',
  TEXT__ADDRESS_STATE: 'newPendingUpdateOverview-span-addressState',
  BUTTON__EDIT_PRODUCTS: 'newPendingUpdateOverview-button-editProducts',
  TEXT__PRODUCT_NAME: 'newPendingUpdateOverview-span-productName',
  TEXT__PRODUCT_QUANTITY: 'newPendingUpdateOverview-span-productQuantity',
  TEXT__PRODUCT_AMOUNT: 'newPendingUpdateOverview-span-productAmount',
  TEXT__TOTAL_LABEL: 'newPendingUpdateOverview-span-totalLabel',
  TEXT__TOTAL_AMOUNT: 'newPendingUpdateOverview-span-totalAmount',
  BUTTON__DELIVERY_FEE: 'newPendingUpdateOverview-button-deliveryFee',
  TEXT__INVOICE_NAME: 'newPendingUpdateOverview-span-invoiceName'
};
exports.OVERVIEW = OVERVIEW;